import { call, fork, select, takeLatest } from 'redux-saga/effects';

import {
  fetchMembersTeam
} from '../api';

import { teamsMembersListActions } from './actions';
import { getTeamMembersListById } from './selectors';

export function* loadTeamMembersList({ payload }) {
  const { teamsMembersListId, teamId, page, query } = payload;

  const teamMemberList = yield select(getTeamMembersListById, teamsMembersListId);

  if (!teamMemberList || teamMemberList.isNew) { //Si se agrega un nuevo miembro, se borra o se edita, esto se tiene que marcar como nuevo o bien reiniciar este store para actualizar la lista
    yield call(fetchMembersTeam, teamsMembersListId, { teamsMembersListId, teamId, page, query });
  }
  else {
    return teamMemberList;
  }
}

//=====================================
//  WATCHERS
//-------------------------------------

export function* watchLoadTeamMembersList() {
  yield takeLatest(teamsMembersListActions.LOAD_TEAM_MEMBERS_LIST, loadTeamMembersList);
}

//=====================================
//  ROOT
//-------------------------------------

export const teamMembersListSagas = [
  fork(watchLoadTeamMembersList),
];
